import { message } from "antd";
import { onError } from "actionware";
import { authLogout } from "../views/login/loginActions";
import * as queryString from "query-string";
import { sessionService } from "redux-react-session";
import { history } from "./../store";
import axios from "axios";
import { redirectToAuthenticate } from "../helpers/auth";
import { getConfig } from './config';

const PATH_INCLUDE_VERSION = [
  "lender/portfolio"
]

export async function apiFetch(
  path,
  method = "GET",
  params,
  headers = {},
  version,
  options = {}
) {
  const isGetRequest = method.toUpperCase() === "GET";
  const query =
    isGetRequest && params ? "?" + queryString.stringify(params) : "";
  const body = !isGetRequest && params ? JSON.stringify(params) : undefined;
  const baseApi = getConfig('LENDER_API');
  const apiVersion = PATH_INCLUDE_VERSION.includes(path) ? ((version !== undefined ? version : "v1") + "/") : "";

  let new_headers

  if (method === "GET") {
    new_headers = new Headers({
      ...headers,
      // Accept: "application/json",
    });
  } else {
    new_headers = new Headers({
      ...headers,
      "Content-Type": "application/json",
      Accept: "application/json",
    });
  }

  // const result = await fetch(`https://qa1.taralite.com/lender-api/${path}${query}`, {
  const result = await fetch(`${baseApi}/${apiVersion}${path}${query}`, {
    headers: new_headers,
    method,
    body,
    credentials: 'include',
  });

  console.log(result)
  return parseResponse(result, options).catch((err) => {
    return Promise.reject(err);
  });
}

export async function authenticatedApiFetch(
  path,
  method = "GET",
  params,
  headers = {},
  version = "v1",
  options = {}
) {
  return apiFetch(path, method, params, headers, version, options);
}

export const griffinInstance = axios.create({
    baseURL: getConfig('GRIFFIN_BASE_API_URL'),
    withCredentials: true,
})

async function parseResponse(serverResponse, options = {}) {
  switch (serverResponse.status) {
    case 200:
      return serverResponse.json();
    case 401: {
      sessionService.deleteSession();
      sessionService.deleteUser();
      redirectToAuthenticate();
      return
    }
    case 403: {
      sessionService.deleteSession();
      sessionService.deleteUser();
      redirectToAuthenticate();
      return
    }
    case 404: {
      if (options.skipNotFoundRedirect) {
        const notFoundError = new Error("Not found");
        notFoundError.status = 404;
        return Promise.reject(notFoundError);
      }
      return history.push("/404");
    }
    default:
      // We expect the server to send us an object with
      // an 'error' prop that contains the error message,
      // in case the response status is not 200 or 401
      const response = await serverResponse.json();
      return Promise.reject(
        response.message ||
          "Error received from server, please try again or contact support"
      );
  }
}

export const capitalize = (str) =>
  str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

export const getInitials = (fullName) =>
  fullName
    .split(" ")
    .slice(0, 2)
    .reduce((initials, [firstLetter]) => initials + firstLetter, "");

// error catch all
onError(({ action, args, error }) => {
  console.error(`Unhandled error in action ${action.name}`, error);
  message.error(
    error instanceof Error
      ? error.message
      : error || "Server error, please try again later or contact support"
  );
});

export async function getRole() {
  const { roles } = await sessionService.loadSession();
  return roles;
}

export async function getLenderId() {
  const { lenderId } = await sessionService.loadSession();
  return lenderId;
}

export async function isAdmin() {
  const role = await getRole();
  return ["ADMIN"].includes(role);
}

export function getMessageID() {
  return crypto.randomUUID().replaceAll("-", "");
}
